import { PublicClientApplication } from '@azure/msal-browser';
import { trackError } from './appinsights/applogs';

export const msalConfig = {
  auth: {
    clientId: window.envconfig.ClientId,
    authority:
      'https://login.microsoftonline.com/e11fd634-26b5-47f4-8b8c-908e466e9bdf',
    redirectUri: window.location.origin,
    validateAuthority: true,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    // Completely disable iframe-based operations for development
    allowNativeBroker: false,
    allowMultipleLogins: false,
    allowRedirectInIframe: false,
    // Disable iframe token acquisition - use only redirect/popup
    tokenRenewalOffsetSeconds: 300, // Refresh 5 minutes before expiry
    loadFrameTimeout: 0, // Disable frame loading
    navigateFrameWait: 0, // Disable frame navigation
    iframeHashTimeout: 0, // Disable iframe hash
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        // Suppress default logging - only track errors
        if (level === 3) { // ErrorLevel
          trackError(new Error(message));
        }
      },
      level: 2,
      piiLoggingEnabled: false,
    }
  },
  //system: {
  //    loggerOptions: {
  //        loggerCallback: (level, message, containsPii) => {
  //            if (containsPii) {
  //                return;
  //            }
  //            switch (level) {
  //                case LogLevel.Error:
  //                    console.error(message);
  //                    return;
  //                case LogLevel.Info:
  //                    console.info(message);
  //                    return;
  //                case LogLevel.Verbose:
  //                    console.debug(message);
  //                    return;
  //                case LogLevel.Warning:
  //                    console.warn(message);
  //                    return;
  //            }
  //        }
  //    }
  //}
};

export const loginRequest = {
  scopes: ['User.Read'],
};

export const apiRequest = {
  scopes: ['api://' + window.envconfig.ClientId + '/user_impersonation'],
  forceRefresh: false, // Changed to false to use cached tokens when available
};

export const appInsightKey = window.envconfig.AppInsightKey;

// Create a singleton MSAL instance
let msalInstance = null;

export const getMsalInstance = () => {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(msalConfig);
  }
  return msalInstance;
};

export const setMsalInstance = (instance) => {
  msalInstance = instance;
};

export const acquireToken = async () => {
  const instance = getMsalInstance();
  const accounts = instance.getAllAccounts();
  
  if (accounts.length === 0) {
    return null;
  }

  try {
    // Try silent token acquisition first
    const response = await instance.acquireTokenSilent({
      ...apiRequest,
      account: accounts[0],
      timeoutInSeconds: 5, // Short timeout
    });
    return response;
  } catch (error) {
    // If silent fails, try popup (only on user interaction)
    if (error.errorCode === 'monitor_window_timeout' || error.errorCode === 'interaction_in_progress') {
      try {
        const response = await instance.acquireTokenPopup(apiRequest);
        return response;
      } catch (popupError) {
        trackError(popupError);
        return null;
      }
    }
    
    trackError(error);
    return null;
  }
};
